import {
  FREE_TIER_MAX_FOLDERS,
  FREE_TIER_MAX_PUBLISHED,
  FREE_TIER_MAX_SCROLLS_PER_FOLDER,
  FREE_TIER_MAX_STARRED_NOTES,
  FREE_TIER_MAX_WORKSPACES,
  MAX_SECTIONS_PER_NOTE,
  PRO_TIER_MAX_FOLDERS,
  PRO_TIER_MAX_PUBLISHED,
  PRO_TIER_MAX_SCROLLS_PER_FOLDER,
  PRO_TIER_MAX_WORKSPACES,
} from "@/lib/plan-limits";

export type PricingPlanFeature = {
  name: string;
  tooltip?: string;
};

const EARLY_ACCESS_SECTIONS_TOOLTIP =
  "Full section access available during early access";
const FEEDBACK_CHAT_TOOLTIP = "Free during the early access period.";

/**
 * User-facing plan bullets. Must match shipped product and server enforcement.
 */
export const PRICING_PLAN_FEATURES: {
  free: readonly PricingPlanFeature[];
  pro: readonly PricingPlanFeature[];
} = {
  free: [
    { name: `${FREE_TIER_MAX_WORKSPACES} workspace` },
    { name: `${FREE_TIER_MAX_FOLDERS} folders per workspace` },
    { name: `${FREE_TIER_MAX_SCROLLS_PER_FOLDER} notes per folder` },
    {
      name: `${MAX_SECTIONS_PER_NOTE} sections per note`,
      tooltip: EARLY_ACCESS_SECTIONS_TOOLTIP,
    },
    { name: `${FREE_TIER_MAX_PUBLISHED} live published notebooks` },
    { name: `${FREE_TIER_MAX_STARRED_NOTES} Starred Notes` },
    {
      name: "Feedback chat with the team",
      tooltip: FEEDBACK_CHAT_TOOLTIP,
    },
  ],
  pro: [
    { name: `${PRO_TIER_MAX_WORKSPACES} workspaces` },
    { name: `${PRO_TIER_MAX_FOLDERS} folders per workspace` },
    { name: `${PRO_TIER_MAX_SCROLLS_PER_FOLDER} notes per folder` },
    { name: `${MAX_SECTIONS_PER_NOTE} sections per note` },
    { name: `${PRO_TIER_MAX_PUBLISHED} live published notebooks` },
    { name: "Unlimited Starred Notes" },
    { name: "Feedback chat with the team" },
  ],
};

export const PRICING_DOWNGRADE_PARAGRAPH =
  "If you downgrade from Pro, your work stays in your account. Extra workspaces, folders, and notes remain visible and become read only on Free. Extra published notebooks pause until you upgrade again, then everything returns instantly.";
